import { useState, useEffect } from "react";
import { breakpoints, screen } from "../theme/grid.js";
var Breakpoint = ((Breakpoint2) => {
  Breakpoint2[Breakpoint2["xxs"] = breakpoints.xxs] = "xxs";
  Breakpoint2[Breakpoint2["xs"] = breakpoints.xs] = "xs";
  Breakpoint2[Breakpoint2["sm"] = breakpoints.sm] = "sm";
  Breakpoint2[Breakpoint2["md"] = breakpoints.md] = "md";
  Breakpoint2[Breakpoint2["lg"] = breakpoints.lg] = "lg";
  Breakpoint2[Breakpoint2["xl"] = breakpoints.xl] = "xl";
  return Breakpoint2;
})(Breakpoint || {});
function getCurrentBreakpoint() {
  const mediaQueryList = Object.entries(screen).reverse().map(([size, mediaQuery]) => {
    return {
      breakpoint: Breakpoint[size],
      mq: window.matchMedia(mediaQuery)
    };
  });
  const matched = mediaQueryList.find((entry) => entry.mq.matches);
  return (matched == null ? void 0 : matched.breakpoint) ?? Breakpoint.xxs;
}
const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(
    typeof window.matchMedia !== "undefined" ? getCurrentBreakpoint() : Breakpoint.xxs
  );
  useEffect(() => {
    const mediaQueryList = Object.values(screen).map((mediaQuery) => {
      const mq = window.matchMedia(mediaQuery);
      const handler = () => {
        setBreakpoint(getCurrentBreakpoint());
      };
      if (mq.addEventListener) {
        mq.addEventListener("change", handler);
      } else if (mq.addListener) {
        mq.addListener(handler);
      }
      return { mq, handler };
    });
    return () => {
      mediaQueryList.forEach(({ mq, handler }) => {
        if (mq.removeEventListener) {
          mq.removeEventListener("change", handler);
        } else if (mq.removeListener) {
          mq.removeListener(handler);
        }
      });
    };
  }, []);
  return breakpoint;
};
export {
  Breakpoint,
  useBreakpoint
};
//# sourceMappingURL=useBreakpoint.js.map
